import Layout from "@pages/user/layout";
import React from 'react';
import LoginForm from '../form/login.form';
import { useLocation } from "react-router";
import ForgetPasswordForm from "../form/forget.form";
import ResetOTPForm from "../form/verifyotp.form";
import ResetPasswordForm from "../form/reset.form";

type Props = {}

const index:React.FC<Props> = ({}) => {
  const location = useLocation();
  return (<>
  
    <Layout>
        {
          ["/login"].includes(location.pathname) ?  <LoginForm/> : 
          ["/forget-password"].includes(location.pathname) ?  <ForgetPasswordForm /> :
          ["/reset-verify-otp"].includes(location.pathname) ?  <ResetOTPForm /> :
          ["/reset-password"].includes(location.pathname) ?  <ResetPasswordForm /> :
          <></>
        }
    </Layout>
  
  
  </>)
}

export default index